export default {
    SET_MEMBER_VERIFICATION_BEGIN: 'SET_MEMBER_VERIFICATION_BEGIN',
    SET_MEMBER_VERIFICATION_SUCCESS: 'SET_MEMBER_VERIFICATION_SUCCESS',
    SET_MEMBER_VERIFICATION_ERROR: 'SET_MEMBER_VERIFICATION_ERROR',
    SET_MEMBER_VERIFICATION_CLEANUP: 'SET_MEMBER_VERIFICATION_CLEANUP'
  };
  